<template>
  <v-row class="" style="flex:none">
    <v-col cols="12" class="main-section-header-mobile-row" v-if="isMobile">
      <v-btn-toggle group true>
        <v-btn class="date-button" depressed small :ripple="false" active-class="active-timeframe" value="all" @click="setTimeFilter('all')">{{ $t('timeFilter.all')}}</v-btn>
        <v-btn class="date-button" depressed small :ripple="false" active-class="active-timeframe" value="inPlay" @click="setTimeFilter('inPlay')">{{ $t('timeFilter.inPlay')}}</v-btn>
        <v-btn class="date-button" depressed small :ripple="false" active-class="active-timeframe" value="today" @click="setTimeFilter('today')">{{ $t('timeFilter.today')}}</v-btn>
        <v-btn class="date-button" depressed small :ripple="false" active-class="active-timeframe" value="tomorrow" @click="setTimeFilter('tomorrow')">{{ $t('timeFilter.tomorrow')}}</v-btn>
        <v-btn class="date-button" depressed small :ripple="false" active-class="active-timeframe" value="future" @click="setTimeFilter('future')">{{ $t('timeFilter.future')}}</v-btn>
      </v-btn-toggle>

    </v-col>
    <v-col cols="12" class="main-section-header-mobile-row" v-if="!isMobile">
      <v-btn-toggle group mandatory v-model="selectedTimeFrame">
        <v-btn class="date-button" depressed small :ripple="false" active-class="active-timeframe" value="all" @click="setTimeFilter('all')">{{ $t('timeFilter.all')}}</v-btn>
        <v-btn class="date-button" depressed small :ripple="false" active-class="active-timeframe" value="inPlay" @click="setTimeFilter('inPlay')">{{ $t('timeFilter.inPlay')}}</v-btn>
        <v-btn class="date-button" depressed small :ripple="false" active-class="active-timeframe" value="today" @click="setTimeFilter('today')">{{ $t('timeFilter.today')}}</v-btn>
        <v-btn class="date-button" depressed small :ripple="false" active-class="active-timeframe" value="tomorrow" @click="setTimeFilter('tomorrow')">{{ $t('timeFilter.tomorrow')}}</v-btn>
        <v-btn class="date-button" depressed small :ripple="false" active-class="active-timeframe" value="future" @click="setTimeFilter('future')">{{ $t('timeFilter.future')}}</v-btn>
      </v-btn-toggle>
    </v-col>
  </v-row>


</template>

<script>
export default {
  name: 'TimeFrameComponent',
  mounted:function(){
  },
  computed:{
    isMobile: function () {
      return this.$store.state.isMobile;
    },
    selectedTimeFrame: {
      get(){
        return this.$store.state.navigations.timeframe;
      },
      set(newTimeFrame){
        return newTimeFrame
      }
    }
  },
  methods:{
    setTimeFilter:function (timefilter) {
      this.$store.commit('setTimeFilter',timefilter);
    }
  }
};
</script>

<style scoped>
  /* trying a better version
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).date-button */
  >>>.theme--light.v-btn.date-button {
    margin-left: 4px;
    margin-top: 16px;
    margin-bottom: 8px;
    margin-right: 0px;
    padding: 4px 8px;
    background-color: #E4E4E4!important;
    font-weight: 700;
    color: #0c1016;
    opacity: 0.36;
    text-transform: none;
    border-radius: 4px;
    border: 0px;
    letter-spacing: unset;
    text-indent: 0;
  }
  >>>.theme--light.v-btn.v-btn--active.date-button,
  >>>.theme--light.v-btn.date-button:hover {
    opacity: 1;
  }
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):first-child.date-button {
    margin-left: 0px;
  }
  .date-button.v-btn.active-timeframe.v-btn--active.v-btn--depressed.theme--light.v-size--small{
    background-color: #E4E4E4!important;
    opacity: 1;
    color: #0c1016;
    border-color: #E4E4E4;

  }
  /* irrelevant
  .active-timeframe{
    color: blue;
  } */
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).date-button:active{
    color: #0c1016;;
  }
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).date-button:visited{

  }
  .row {
    margin: 0px;

  }
  .main-section-header-mobile-row{
    padding: 0px;
    margin: 0px;
    justify-content: space-between;
  }
  >>>.date-button.v-btn:not(.v-btn--round).v-size--small {
    height: auto !important;
  }
  >>>.date-button .v-btn__content {
    line-height: 16px;
  }
  >>>.date-button.v-btn:not(.v-btn--text):not(.v-btn--outlined):focus::before,
  >>>.date-button.v-btn:not(.v-btn--text):not(.v-btn--outlined):hover::before,
  >>>.date-button.theme--light.v-btn--active:hover::before,
  >>>.date-button.theme--light.v-btn--active::before,
  >>>.date-button.v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active::before {
	  opacity: 0;
  }
  >>>.v-btn-toggle > .date-button.v-btn.v-btn:first-child {
	  border-top-left-radius: 4px;
	  border-bottom-left-radius: 4px;
  }
  >>>.v-btn-toggle > .date-button.v-btn.v-btn:last-child {
  	border-top-right-radius: 4px;
	  border-bottom-right-radius: 4px;
  }

</style>
